<template>
    <v-form @submit.prevent="submit">
        <v-card flat class="fill-height">
            <v-card-text class="px-4 py-4">
                <!-- Category Selection -->
                <div class="mb-3">
                    <div class="text-caption grey--text text--darken-1 mb-1 text-uppercase" style="font-size: 0.65rem; letter-spacing: 0.5px; font-weight: 500;">З категорії</div>
                    <v-select
                        v-model="selected_from_category"
                        :items="budget_categories"
                        item-text="category.display_name"
                        item-value="id"
                        return-object
                        outlined
                        dense
                        hide-details
                        class="modern-select"
                    ></v-select>
                    <div class="text-caption grey--text mt-1" style="font-size: 0.75rem;">Наявно: <span class="font-weight-medium">{{left_from_category | numberify}}</span></div>
                </div>

                <div class="mb-4">
                    <div class="text-caption grey--text text--darken-1 mb-1 text-uppercase" style="font-size: 0.65rem; letter-spacing: 0.5px; font-weight: 500;">У категорію</div>
                    <v-select
                        v-model="selected_to_category"
                        :items="budget_categories"
                        item-text="category.display_name"
                        item-value="id"
                        return-object
                        outlined
                        dense
                        hide-details
                        class="modern-select"
                    ></v-select>
                    <div class="text-caption grey--text mt-1" style="font-size: 0.75rem;">Залишиться: <span class="font-weight-medium">{{left_to_category | numberify}}</span></div>
                </div>

                <!-- Amount Display -->
                <div class="text-center my-4">
                    <div class="text-caption grey--text text--darken-1 mb-1 text-uppercase" style="font-size: 0.65rem; letter-spacing: 0.5px; font-weight: 500;">Сума переказу</div>
                    <div class="display-1 font-weight-bold primary--text" style="font-size: 2.5rem !important;">
                        {{formattedAmount}}
                    </div>
                </div>

                <!-- Number Pad -->
                <v-container class="pa-0 my-3">
                    <v-row class="mx-0">
                        <v-col cols="4" class="pa-1" v-for="num in [1,2,3]" :key="'row1-'+num">
                            <v-btn 
                                large
                                block
                                text
                                @click="appendNumber(num)"
                                class="number-btn"
                                style="font-size: 1.5rem; height: 56px;"
                                :ripple="false"
                            >
                                {{num}}
                            </v-btn>
                        </v-col>
                    </v-row>
                    <v-row class="mx-0">
                        <v-col cols="4" class="pa-1" v-for="num in [4,5,6]" :key="'row2-'+num">
                            <v-btn 
                                large
                                block
                                text
                                @click="appendNumber(num)"
                                class="number-btn"
                                style="font-size: 1.5rem; height: 56px;"
                                :ripple="false"
                            >
                                {{num}}
                            </v-btn>
                        </v-col>
                    </v-row>
                    <v-row class="mx-0">
                        <v-col cols="4" class="pa-1" v-for="num in [7,8,9]" :key="'row3-'+num">
                            <v-btn 
                                large
                                block
                                text
                                @click="appendNumber(num)"
                                class="number-btn"
                                style="font-size: 1.5rem; height: 56px;"
                                :ripple="false"
                            >
                                {{num}}
                            </v-btn>
                        </v-col>
                    </v-row>
                    <v-row class="mx-0">
                        <v-col cols="4" class="pa-1">
                            <v-btn 
                                large
                                block
                                text
                                @click="appendNumber('.')"
                                class="number-btn"
                                style="font-size: 1.5rem; height: 56px;"
                                :ripple="false"
                            >
                                .
                            </v-btn>
                        </v-col>
                        <v-col cols="4" class="pa-1">
                            <v-btn 
                                large
                                block
                                text
                                @click="appendNumber(0)"
                                class="number-btn"
                                style="font-size: 1.5rem; height: 56px;"
                                :ripple="false"
                            >
                                0
                            </v-btn>
                        </v-col>
                        <v-col cols="4" class="pa-1">
                            <v-btn 
                                large
                                block
                                text
                                @click="backspace"
                                class="number-btn"
                                style="font-size: 1.2rem; height: 56px;"
                                :ripple="false"
                            >
                                <v-icon>mdi-backspace-outline</v-icon>
                            </v-btn>
                        </v-col>
                    </v-row>
                </v-container>

            </v-card-text>
            
            <!-- Bottom Action Button -->
            <v-card-actions class="px-4 pb-4">
                <v-btn 
                    large
                    block
                    color="primary"
                    depressed
                    @click="submit"
                    :disabled="!isValidAmount"
                    style="height: 48px; border-radius: 24px; text-transform: none; font-size: 16px; letter-spacing: -0.2px;"
                >
                    Переказати кошти
                </v-btn>
            </v-card-actions>
        </v-card>
    </v-form>
</template>

<style scoped>
.number-btn::before {
  background-color: transparent !important;
}
.number-btn:focus::before,
.number-btn:hover::before {
  opacity: 0 !important;
}
.modern-select >>> .v-input__control {
  border-radius: 8px;
}
.modern-select >>> .v-select__selections {
  font-weight: 400;
  font-size: 14px;
}
.modern-select >>> fieldset {
  border-color: #e0e0e0;
}
.modern-select:not(.v-input--is-focused) >>> fieldset {
  border-width: 1px;
}
</style>

<script>
  export default {
    data: () => ({
      selected_to_category: '',
      selected_from_category: '',
      transfer_amount: '0',
    }),
    watch: {
        current_budget(budget) {
            if (budget && budget.id) {
                this.fetchBudgetCategories(budget.id);
            }
        },
        budget_categories(categories) {
            if (categories && categories.length > 0 && !this.selected_from_category) {
                this.selected_to_category = this.budgetCategoryWithLowestLeftAmount;
                this.selected_from_category = this.budgetCategoryWithHightestLeftAmount;
            }
        }
    },
    methods:{
        setAmount(amount) {
            this.transfer_amount = amount.toString();
        },
        appendNumber(num) {
            if (this.transfer_amount === '0' && num !== '.') {
                this.transfer_amount = num.toString();
            } else if (num === '.' && this.transfer_amount.includes('.')) {
                // Don't add another decimal point
                return;
            } else {
                this.transfer_amount += num.toString();
            }
        },
        clearAmount() {
            this.transfer_amount = '0';
        },
        backspace() {
            if (this.transfer_amount.length > 1) {
                this.transfer_amount = this.transfer_amount.slice(0, -1);
            } else {
                this.transfer_amount = '0';
            }
        },
        cancel() {
            this.$router.push('/');
        },
        submit () {
            const payload = {
                'from_category': this.selected_from_category.id,
                'to_category': this.selected_to_category.id,
                'amount': this.transfer_amount,
            }
            this.$store.dispatch('budgets/transferAmountBetweenBudgetCategories', payload).then(() => {
                this.$router.push('/');
            });
        },
        fetchBudgetCategories(budget_id) {
            return this.$store.dispatch('budgets/fetchBudgetCategories', budget_id)
        },
    },
    computed: {
      formattedAmount() {
        const amount = parseFloat(this.transfer_amount) || 0;
        return amount.toLocaleString('uk-UA', {
          minimumFractionDigits: 2,
          maximumFractionDigits: 2
        }) + ' ₴';
      },
      isValidAmount() {
        const amount = parseFloat(this.transfer_amount);
        return amount > 0 && this.selected_from_category && this.selected_to_category;
      },
      current_budget() {
        return this.$store.getters['budgets/getCurrentBudget'];
      },
      budget_categories() {
        return this.$store.getters['budgets/getBudgetCategories'];
      },
      left_to_category() {
        let selected_category_letf = this.selected_to_category ? this.selected_to_category.left_amount: 0;
        return selected_category_letf + parseFloat(this.transfer_amount);
      },
      left_from_category() {
        let selected_from_category_left = this.selected_from_category ? this.selected_from_category.left_amount: 0;
        return selected_from_category_left - parseFloat(this.transfer_amount);
      },
      budgetCategoryWithLowestLeftAmount() {
        return this.$store.getters['budgets/getBudgetCategoryWithLowestLeftAmount'];
      },
      budgetCategoryWithHightestLeftAmount() {
        return this.$store.getters['budgets/getBudgetCategoryWithHightestLeftAmount'];
      },
    },
    created() {
        // Load budget categories if current budget is already selected
        if (this.current_budget && this.current_budget.id) {
            this.fetchBudgetCategories(this.current_budget.id);
        }
    },
    filters: {
      numberify: function (value) {
          if (!value) return '0';
          return parseFloat(value).toFixed(2);
      }
    }
  }
</script>